import { ConfigurarRelatorioService } from '../../../shared/services/apis/relatorio-interno/configurar-relatorio.service';
import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario-admin/usuario-admin.service';
import { UsuarioAdminLookupResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-lookup.response';
import { RelatorioRequest } from '../../../shared/services/requests/relatorio-interno/relatorio.request';
import { RelatorioResponse } from '../../../shared/services/responses/relatorio-interno/relatorio.response';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';

@Component({
  selector: 'app-configurar-relatorio-cadastro',
  imports: [
    MenuComponent,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSelectModule,
    RouterModule,
  ],
  providers: [],
  templateUrl: './configurar-relatorio-cadastro.component.html',
  styleUrl: './configurar-relatorio-cadastro.component.css',
})
export class ConfigurarRelatorioCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private usuarioAdminService: UsuarioAdminService,
    private configurarRelatorioService: ConfigurarRelatorioService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.moduloEnum = ModuloEnum.InteligenciaDados;
    this.funcionalidadeEnum = FuncionalidadeEnum.InteligenciaDados_ConfigurarRelatorio;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _usuarioLookupResponse: UsuarioAdminLookupResponse;
  public _relatorioResponse: RelatorioResponse;
  public idRelatorio: number | null = null;

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('idRelatorio')) {
      this.idRelatorio = parseInt(this.activatedRoute.snapshot.paramMap.get('idRelatorio') ?? '');
    }

    this.model = this.formBuilder.group({
      tituloRelatorio: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      linkRelatorio: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      listaIdPerfil: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
    });

    this.popularLookup();

    if (this.idRelatorio) {
      this.popularDadosUsuario();
    }
  }

  popularLookup(): void {
    this.usuarioAdminService.Lookup().subscribe({
      next: (usuarioLookupResponse: UsuarioAdminLookupResponse) => {
        if (usuarioLookupResponse.isError) {
          this.alertService.show('Erro', usuarioLookupResponse.errorDescription, AlertType.error);
          return;
        }

        this._usuarioLookupResponse = usuarioLookupResponse;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  popularDadosUsuario(): void {
    this.configurarRelatorioService.ObterPorId(this.idRelatorio || 0).subscribe({
      next: (relatorioResponse: RelatorioResponse) => {
        if (relatorioResponse.isError) {
          this.alertService.show('Erro', relatorioResponse.errorDescription, AlertType.error);
          return;
        }

        this.model
          .get('tituloRelatorio')
          ?.setValue(relatorioResponse.relatorioPerfil.relatorio.tituloRelatorio);
        this.model.get('linkRelatorio')?.setValue(relatorioResponse.relatorioPerfil.relatorio.linkRelatorio);
        this.model.get('listaIdPerfil')?.setValue(relatorioResponse.relatorioPerfil.listaIdPerfil);

        this._relatorioResponse = relatorioResponse;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }

    const criarRelatorioRequest: RelatorioRequest = new RelatorioRequest();

    criarRelatorioRequest.tituloRelatorio = this.model.get('tituloRelatorio')?.value.trim();
    criarRelatorioRequest.linkRelatorio = this.model.get('linkRelatorio')?.value.trim();
    criarRelatorioRequest.listaIdPerfil = this.model.get('listaIdPerfil')?.value
      ? this.model.get('listaIdPerfil')?.value
      : [];

    if (this.model.get('listaIdPerfil')?.value === '') {
      this.alertService.show('Erro', 'Informe um perfil de acesso para o relatório.', AlertType.error);
      return;
    }

    if (!this.idRelatorio) {
      this.novo(criarRelatorioRequest);
    } else {
      this.alterar(criarRelatorioRequest);
    }
  }

  private novo(criarRelatorioRequest: RelatorioRequest): void {
    this._isLoading = true;
    this.configurarRelatorioService.Incluir(criarRelatorioRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Relatório incluido com sucesso.', AlertType.success);
        this.router.navigate(['/inteligencia-dados/configurar-relatorio']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private alterar(criarRelatorioRequest: RelatorioRequest): void {
    this._isLoading = true;

    this.configurarRelatorioService.Alterar(this.idRelatorio ?? 0, criarRelatorioRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Relatório alterado com sucesso.', AlertType.success);
        this.router.navigate(['/inteligencia-dados/configurar-relatorio']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }
}
